module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    domProps: {
      "innerHTML": _vm._s(_vm.question.statement)
    }
  }), _vm._v(" "), _vm._l((_vm.question.itemsRows), function(itemRow, rowIndex) {
    return _c('div', {
      staticClass: "row"
    }, [_c('h4', {
      staticClass: "col-xs-12 text-muted",
      domProps: {
        "innerHTML": _vm._s(itemRow.label)
      }
    }), _vm._v(" "), _vm._l((itemRow.fields), function(field, fieldIndex) {
      return [_c('div', {
        staticClass: "col-xs-12 col-md-6 col-lg-4"
      }, [_c(_vm.getFieldComponent(field), {
        key: field.uuid,
        ref: "fields",
        refInFor: true,
        tag: "component",
        attrs: {
          "field": field,
          "fieldAnswer": _vm.getFieldAnswer(itemRow, field),
          "isDisabled": _vm.disabledAttribute
        },
        on: {
          "fieldUpdated": _vm.onFieldUpdated
        }
      })], 1)]
    })], 2)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27ae9fa6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/quizzes/questions/ItemsQuestion.vue
// module id = 706
// module chunks = 1